
import React from 'react';
import { TextField } from 'office-ui-fabric-react/lib/TextField';

import { utils } from '../../../core';

const ObjectEditAttributeInteger = ({
    attribute,
    onChange,
    value
}) => {

    const handleChange = (e) => {
        if (onChange) {
            onChange(attribute.name, e.target.value);
        }
    }

    const readOnly = false;

    return (
        <TextField
            label={attribute.title}
            value={value}
            disabled={readOnly}
            readOnly={readOnly}
            styles={utils.styles.TEXT_BOX_STYLES}
            onChange={handleChange}
        />
    );
}

export default ObjectEditAttributeInteger;
